import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

export const DEFAULT_SYSTEM_SETTINGS = {
  nama_sistem: 'Sistem Informasi Akreditasi',
  nama_kampus: 'Politeknik Negeri Manado',
  deskripsi_sistem:
    'Sistem informasi untuk pengelolaan, arsip, dan rekap data akreditasi program studi.',
  periode_akreditasi: '2025/2027',
  footer_text:
    'Copyright 2025 Politeknik Negeri Manado. Sistem Informasi Akreditasi Kampus.',
};

function normalizeSettings(data) {
  if (!data) return DEFAULT_SYSTEM_SETTINGS;

  return {
    nama_sistem: data.nama_sistem || DEFAULT_SYSTEM_SETTINGS.nama_sistem,
    nama_kampus: data.nama_kampus || DEFAULT_SYSTEM_SETTINGS.nama_kampus,
    deskripsi_sistem:
      data.deskripsi_sistem || DEFAULT_SYSTEM_SETTINGS.deskripsi_sistem,
    periode_akreditasi:
      data.periode_akreditasi || DEFAULT_SYSTEM_SETTINGS.periode_akreditasi,
    footer_text: data.footer_text || DEFAULT_SYSTEM_SETTINGS.footer_text,
  };
}

function useSystemSettings() {
  const [settings, setSettings] = useState(DEFAULT_SYSTEM_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadSettings = async () => {
      setLoading(true);
      setError('');

      const { data, error: fetchError } = await supabase
        .schema('akreditasi')
        .from('system_settings')
        .select(
          'nama_sistem, nama_kampus, deskripsi_sistem, periode_akreditasi, footer_text'
        )
        .limit(1)
        .maybeSingle();

      if (!isMounted) return;

      if (fetchError) {
        setError(fetchError.message);
        setSettings(DEFAULT_SYSTEM_SETTINGS);
      } else {
        setSettings(normalizeSettings(data));
      }

      setLoading(false);
    };

    loadSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  return { settings, loading, error };
}

export default useSystemSettings;
